<template>
  <div>
    <b-table 
      :data="data"
      >
      <template slot-scope="props" >
        <div class="column d-flex align-items-center justify-content-between"> 
          <h3 class="textColumn mr-5" field="name">
            {{ props.row.name.toLowerCase() }}
          </h3>
          <div class="d-flex align-items-center justify-content-center inner-content">
            <h3 class="mr-3 badge badge-pill badge-info">
              <strong>
                {{ props.row.entities }}
              </strong>
            </h3>
            <div 
              v-if="props.row.segmentType !== 'MANUAL'"
              class="edit d-flex align-items-center justify-content-center"
              field="id" 
              @click="redirectFromPath(props.row.id, false)">
              <AppLink>
                <b-icon icon="pencil-alt"></b-icon>
              </AppLink>
            </div>
            <div 
              v-if="props.row.segmentType !== 'MANUAL'"
              class="edit d-flex align-items-center justify-content-center"
              field="id" 
              @click="redirectFromPath(props.row.id, true)">
              <AppLink>
                <b-icon icon="copy"></b-icon>
              </AppLink>
            </div>
          </div>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import AppLink from './AppLink'

export default {
  components: {
    AppLink
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: () => 10
    },
    page: {
      type: Number,
      default: () => 1
    },
    pages: {
      type: Number,
      default: () => 1
    },
    limit: {
      type: Number,
      default: () => 1
    }
  },
  methods: {
    change(value) {
      this.$emit('pagination', value)
    },
    redirectFromPath(id, isAClone) {
      !isAClone
        ? this.$router.push(`/${id}`)
        : this.$router.push(`/clone/${id}`)
    },
  }
}
</script>

<style lang="scss">
.edit {
  width: 48px;
  height: 48px;
  background: #F2F2F2; 
  border-radius: 50px;
  display: flex;
  align-items: center;
  a {
    color: #6D6D77;
    text-decoration: none;
  }
}
.edit + .edit {
  margin-left: 5px;
}
.column {
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  height: 72px;
  margin-bottom: 12px;
  display: flex !important;
  justify-content: space-between;
  h3 {
    text-align: left;
    display: block;
    display: -webkit-box;
    max-height: 150px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 800px;
  }
  .inner-content {
    .badge-info {
      padding: 8px !important;
    }
    h3 {
      strong {
        color: white;
      }
    }
    h3:nth-child(1) {
      transition: 400ms ease-out;
      &:hover {
        transition: 400ms ease-out;
        transform: scale(1.2);
      }
    }
  }
}

.textColumn {
    font-weight: 600;
    font-size: 14px;
    color: #6D6D77; 
    text-transform: capitalize; 
}

.table td, .table th {
    border: 1px solid #fff !important;
    border-width: 0 0 1px;
    padding: 0.5em 0.75em;
    vertical-align: top;
}
@media(max-width: 400px) {
  .column{
    h3 {
      max-width: 130px;
    }
  }
}
</style>